import { render } from "./SlidingBannerWidget.vue?vue&type=template&id=0a782e81"
import script from "./SlidingBannerWidget.vue?vue&type=script&lang=js"
export * from "./SlidingBannerWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__